import { render, staticRenderFns } from "./r-attribute-dialog.vue?vue&type=template&id=7149a382&scoped=true"
import script from "./r-attribute-dialog.vue?vue&type=script&lang=js"
export * from "./r-attribute-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-attribute-dialog.vue?vue&type=style&index=0&id=7149a382&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7149a382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7149a382')) {
      api.createRecord('7149a382', component.options)
    } else {
      api.reload('7149a382', component.options)
    }
    module.hot.accept("./r-attribute-dialog.vue?vue&type=template&id=7149a382&scoped=true", function () {
      api.rerender('7149a382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/attribute/r-attribute-dialog.vue"
export default component.exports